// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2kEad","requiredAsterisk":"Info_requiredAsterisk__2IQGN"};